export default "__VITE_ASSET__Cbwp8k_v__"